import { createContext, useContext } from "react";
import type { PartnerMark } from "../../lib/partner-branding";

const PartnerMarkContext = createContext<PartnerMark | null>(null);

export const PartnerMarkProvider = PartnerMarkContext.Provider;

/**
 * Partner mark data: name, logo URL, and the derived fallback initial. Lets the
 * mark tiles read branding directly instead of prop-drilling it through the
 * scene/ceremony tree.
 */
export function usePartnerMark(): PartnerMark {
  const ctx = useContext(PartnerMarkContext);
  if (!ctx) {
    throw new Error("usePartnerMark must be used within PartnerMarkProvider");
  }
  return ctx;
}
